<template>
<div>
    <!-- fixed-bottom-nav -->
    <!-- <div class="bottombar-large" style="margin-top:5em; margin-left: -2em; width: 400px;"> -->
    <div class="bottombar-large" style="margin-top:5em; margin-left: -2em; width: 100%;">
        <div style="padding-left:1em;">
            <a href="/"><i class="fa fa-list"></i><br><span>Feeds</span></a>
            <a href="/shop"><i class="fa fa-shopping-bag"></i><br><span>Bag</span></a>
            <a href="/account"><i class="fa fa-search"></i><br><span>Account</span></a>
            <a href="/notifications"><i class="fa fa-bell"></i><sup v-if="notifications_alert > 0" class="notify-alert">{{notifications_alert}}</sup><br><span>Notifications</span></a>
            <a href="/cart"><i class="fa fa-user"></i><br><span>Account</span></a>
            <!-- <a href="#news" style="font-size:22px;"><i class="fa fa-plus"></i><span>Add</span></a> -->
        </div>
    </div>

    <!---mobile-->
    <!-- <div class="bottombar" style="margin-top:15em; margin-left: -2em;width: 150%;"> -->
    <div class="bottombar">
        <!-- <div style="margin-left:2.5em;"> -->
        <div>
            <a href="/"><i id="m_trending" class="fas fa-store-alt"></i><br><span>Home</span></a>
            <a href="/orders"><i id="m_orders" class="fas fa-shopping-basket"></i><sup v-if="notifications_alert > 0" class="notify-alert">{{notifications_alert}}</sup><br><span>Orders</span></a>
            <a href="/account"><i id="m_account" class="fas fa-cog"></i><sup v-if="notifications_alert > 0" class="notify-alert">{{notifications_alert}}</sup><br><span>Settings</span></a>
        </div>
    </div>
    <!--./mobile-->
   
    <!--./ fixed-bottom-nav -->
 </div>
</template>

<style>
    .bottombar{
        /* margin-bottom: 2em;
        margin-right: 4em;
        margin-left: 3em; 
        width: 80%;
        border-radius: 18px; */
        background-color: #f9f9f9;
        padding: 0.8em 0.4em;
    }
    .bottombar a {
        width: 32%;
        line-height: 0.2;
        color: #f5d33e;
        font-size: 1.4em;
    }
    .bottombar a i{
        color: #0e0d0d;
    }.bottombar a span{
        color: #0e0d0d;
    }
    .notify-alert{
        background: #ff3c00;
        color: #ffffff;
        font-size: 11px;
        padding: 0.2em 0.42em;
        border-radius: 50%;
    }
</style>


<script>
import services from './../../services/service'; // Service Class
let service = new services();

export default {
    name: 'MenuBottom',
    data () {
        return {
            user:{},
            notifications:{},
            notifications_alert:0,
            active_shop_together_alert:0,
        }
    },

    methods: {
        preset() {
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.user.user_id = value.user_id;
                    self.getNotifications();
                }else {
                    // self.$router.push('login');
                }
            });
        },

        getNotifications(){
            service.getNotifications(this, this.user.user_id).then(response => {
                if(response.body.status == 200) {
                    this.notifications_alert = response.body.data_alert_total;
                }
            }).catch((err) => {})
        },
    },

    mounted: function() {
        let path = this.$route.path;
        if(path == "/"){document.getElementById("m_trending").style.color = "#ffffff";}
        if(path == "/orders"){document.getElementById("m_orders").style.color = "#ffffff";}
        if(path == "/notifications"){document.getElementById("m_notifications").style.color = "#ffffff";}
        if(path == "/account"){document.getElementById("m_account").style.color = "#ffffff";}
    },
    created: function() {
        if(localStorage.getItem("active_shop_together_alert")==1){
            this.active_shop_together_alert = 1;
        }
        // this.notifications.alert_no = 5;
        this.preset();
    }
}
</script>


// WEBPACK FOOTER //
// menubottom.vue?873c0d58